var map = {
	"./locales/modules/ru-RU/footer.js": "0f9d",
	"./locales/modules/ru-RU/guide.js": "8060",
	"./locales/modules/ru-RU/index.js": "11a5",
	"./locales/modules/ru-RU/system.js": "5b87",
	"./locales/modules/ru-RU/user.js": "7537"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9eba";